
import {  WBComponent } from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import React from "react";
import { defaultDropList } from "../Data/WBComponentDefaults";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import CreateAttributeList from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import LayoutNode, { getNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import WebDesigner from "../WebDesigner";
import { GetNodeComponenentAttributeBinding, GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";

export default class BeforeAndAfter extends WBComponent {



    constructor(){
        super();
        this.typename = wBComponentTypeNames.beforeAndAfter;
        this.displayName = "Before & After";
        this.dropList = defaultDropList;
        this.editList = ["beforeAndAfterList",...CreateAttributeList(true,false,false,true,false,false)];
        this.primaryEditAttributes = ["beforeAndAfterList"];
        this.icon = <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 576 512" fill="currentColor"><path d="M160 80H512c8.8 0 16 7.2 16 16V320c0 8.8-7.2 16-16 16H490.8L388.1 178.9c-4.4-6.8-12-10.9-20.1-10.9s-15.7 4.1-20.1 10.9l-52.2 79.8-12.4-16.9c-4.5-6.2-11.7-9.8-19.4-9.8s-14.8 3.6-19.4 9.8L175.6 336H160c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zM96 96V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120zm208 24a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/></svg>
       
    }

    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {
     
        return [
            new AttributeDefinition("beforeAndAfterList","Images","",AttributeInputType.ImageField,[],{min:0,max:2,step:1,unit:""}),
          
        ]
    }


    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        thisLayout.screenSizeStyleAttributes[ScreenSize.Desktop] ={height:"360px",width:"400px"};
    }
   RenderLayout({ component, children, screenSize,isEditor,userContext: siteData }: WBRenderProps): JSX.Element {
       
    // return         let sliderContainer = createGenericDom('div', 'before-after-container update-on-save');

    const imageList = getNodeComponentAttributeValue(component,"beforeAndAfterList","").trim();
    const imageListArray = imageList.split(",");
   
    const imgA = imageListArray.length>0&&imageListArray[0].length>1?"url("+imageListArray[0]+")":"grey";
    const imgB = imageListArray.length>1?"url("+imageListArray[1]+")":"#333";



    // sliderContainer.innerHTML = "<div class='b-a-img after' style=''></div><div class = 'b-a-img before''></div><input type='range' class='slider' min='0' max='100' value='50' oninput='beforeAfterOnInput(this);'/>";

    return <>
    
        <style>{bAndACSS}</style>
        <div {...GetNodeDomAttributes("v-before-after before-after-container max-100",component,screenSize,isEditor)} {...GetNodeComponenentAttributeBinding(component,isEditor)}>

        <div className='b-a-img after'
            style={{background:imgB,backgroundPosition:"left center",backgroundSize:"cover"}}
        > 
        </div>
        <div className = 'b-a-img before'
                 style={{background:imgA,backgroundPosition:"left center",backgroundSize:"cover"}}
        >
        </div>
        <input type='range' className='slider' min='0' max='100' defaultValue='50' onInput={(e)=>{


            let slider = e.target as HTMLInputElement;
            if(slider.parentElement&&slider.parentElement.children.length>=1){

                let before = slider.parentElement.children[1] as HTMLElement;
                let width =  slider.value + "%";
                 before.style.clipPath = `polygon(0 0,${width} 0, ${width} 100%, 0 100%)`
            
            }

            
        }} />
        </div>
        </>
   
   }



}

const bAndACSS = `
.before-after-container {
    position: relative;
    width: 800px;
    height: 600px;
    overflow: hidden;
}

    .before-after-container > .b-a-img {
        position: absolute;
        height: 100%;
        width: 100%;
        left: 0;
        top: 0;
        bottom: 0;
        background-position: left center !important;
        background-size: cover !important;
    }

    .before-after-container > input {
        position: absolute;
        top: 0;
        left: 0px;
        width: 100%; /*required for firefox*/
        height: 100%;
        margin: 0;
        padding: 0;
        -webkit-appearance: none; /* Override default CSS styles */
        appearance: none;
        background: none;
        cursor: ew-resize;
        opacity: 0;
    }

.b-a-img.before.animate {
    animation: slider-bounce 4s steps(40) infinite;
}

.b-a-img.before {
   clip-path: polygon(0 0,50% 0, 50% 100%, 0 100%);
}







.canvas.slider{
    pointer-events: none;
}

`